/**
 * The words the borrower emails use for a scenario's loan type and purpose (LOAN PARAMETERS,
 * headings, subjects) — the same on every page and in every send.
 */
import { loanTypesOf } from '../lender-pricing-fields.js';

/**
 * "Loan Purpose": "Cash-Out" for a cash-out refinance (the user's wording, 2026-09-25),
 * "Rate/Term Refinance", "Purchase"; "" when the scenario carries no purpose.
 */
export function emailLoanPurposeLabel(loanPurpose: unknown): string {
  const p = String(loanPurpose ?? '').trim();
  if (!p) return '';
  if (/cash/i.test(p)) return 'Cash-Out';
  if (/refi|rate/i.test(p)) return 'Rate/Term Refinance';
  return 'Purchase';
}

/** "Loan Type": the picked loan types ("DSCR", "Conventional / FHA", "HELOC"). */
export function emailLoanTypeLabel(inputs: Record<string, unknown> | null | undefined): string {
  return loanTypesOf(inputs).join(' / ');
}

/** The email's headline words for a DSCR scenario: "DSCR Cash-Out" / "DSCR Purchase" / "DSCR Rate/Term Refinance". */
export function dscrHeadline(loanPurpose: string): string {
  const purpose = loanPurpose.trim();
  return purpose ? `DSCR ${purpose}` : 'DSCR Investor';
}
